if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (this.form) {
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]') || this.querySelector('button[name="add"]');
      if (this.submitButton && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    getCart() {
      if (!this.cart || !document.body.contains(this.cart)) {
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }
      return this.cart;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitBtn = this.submitButton || this.querySelector('[type="submit"]') || this.querySelector('button[name="add"]');
      if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
      }
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        }
      };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const cart = this.getCart();

      if (this.dataset.cartType !== 'page' && cart && typeof cart.getSectionsToRender === 'function') {
        try {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
        } catch (e) {
          console.warn('Error setting up cart sections:', e);
        }
      }
      config.body = formData;

      const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

      fetch(`${addUrl}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            if (submitBtn) {
              const soldOutMessage = submitBtn.querySelector('.sold-out-message');
              if (soldOutMessage) {
                submitBtn.setAttribute('aria-disabled', 'true');
                const textSpan = submitBtn.querySelector('span:not(.sold-out-message)');
                if (textSpan) textSpan.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
            }
            this.error = true;
            return;
          } else if (this.dataset.cartType === 'page') {
            window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          const currentCart = this.getCart();

          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                if (currentCart && typeof currentCart.renderContents === 'function') {
                  currentCart.renderContents(response);
                }
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else if (currentCart && typeof currentCart.renderContents === 'function') {
            currentCart.renderContents(response);
          } else {
            // Fallback if no cart drawer component
            window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (submitBtn) {
            submitBtn.classList.remove('loading');
            if (!this.error) submitBtn.removeAttribute('aria-disabled');
          }
          const currentCart = this.getCart();
          if (currentCart && currentCart.classList.contains('is-empty')) {
            currentCart.classList.remove('is-empty');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
